interface LaunchTemplatePrimaryDisabledReasonOptions {
  isTemplatePublished: boolean;
  isWorkflowUntitled: boolean;
  loadingTemplateData: boolean;
  templateDataError: boolean;
  templateWorkflowId: UUID | null;
}

export function getLaunchTemplatePrimaryDisabledReason({
  isTemplatePublished,
  isWorkflowUntitled,
  loadingTemplateData,
  templateDataError,
  templateWorkflowId,
}: LaunchTemplatePrimaryDisabledReasonOptions) {
  if (!templateWorkflowId) return 'Select a template';
  if (loadingTemplateData) return 'Loading template...';
  if (templateDataError) return 'Unable to load template';
  if (!isTemplatePublished) return 'Publish template to launch';
  if (isWorkflowUntitled) return 'Give your workflow a name';
  return '';
}
